import axios from 'axios';
import { getAxiosConfig, getDomainOrigin } from 'utils/serverConfig';

interface IApiResponse<T> {
    status: boolean;
    data: T | null;
    statusCode: number;
}

export const getFloatBalanceByPartnerId = async (
    partnerId: string,
    groupName: string,
    walletUserId: string,
    productId: string
): Promise<IApiResponse<any>> => {
    try {
        const { status, data } = await axios(
            `${getDomainOrigin()}/api/mpos/partner/${partnerId}/user/wallet/balance?wallet_user_id=${walletUserId}&product_id=${productId}&group_name=${groupName}`,
            {
                method: 'GET',
                ...getAxiosConfig(),
            }
        );

        return {
            status: status === 200,
            data: data || null,
            statusCode: status,
        };
    } catch (e: any) {
        return {
            status: false,
            data: null,
            statusCode: e?.response?.status || 500,
        };
    }
};
